<template>
  <div class="panel">
    <div class="panel-head">
      <div class="panel-title">{{ $t('chi113') }}</div>
      <span class="unit">{{ $t('chi114') }}</span>
    </div>
    <div class="panel-body">
      <template v-if="sorted.length > 0">
        <div class="hbars">
          <div v-for="p in sorted" :key="p.name" class="hrow">
            <div class="hname" :title="`${p.name} · ${fmt(p.number, 0)} ${$t('chi114')}`">{{ p.name }}</div>
            <div class="htrack">
              <div
                class="hbar"
                :style="{ width: width(p.number) + '%' }"
                :title="`${p.name} · ${fmt(p.number, 0)} ${$t('chi114')}`"
              >{{ fmt(p.number, 0) }}</div>
            </div>
            <div class="hval"><b>{{ fmt(p.number, 0) }}</b> {{ $t('chi114') }}</div>
          </div>
        </div>
      </template>
      <div v-else class="empty">{{ $t('chi9') }}</div>
    </div>
  </div>
</template>

<script>
import { fmt } from "./statUtils.js";

export default {
  name: "PlayRankBars",
  props: {
    // getPlayHistoryStatistics / getHistoryMediaStatistics 返回 [{name, number}]
    list: { type: Array, default: () => [] },
  },
  computed: {
    sorted() {
      return [...this.list].sort((a, b) => b.number - a.number);
    },
    max() {
      return Math.max(...this.sorted.map((p) => p.number), 0);
    },
  },
  methods: {
    fmt,
    width(n) {
      if (this.max <= 0) return 0;
      return Math.max(4, (n / this.max) * 100);
    },
  },
};
</script>

<style lang="scss" scoped>
.panel {
  background: #fff;
  border: 1px solid #dcecf4;
  border-radius: 15px;
  box-shadow: 0 8px 28px rgba(31, 142, 190, 0.08);
  overflow: hidden;
}
.panel-head {
  padding: 16px 18px;
  border-bottom: 1px solid #dcecf4;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.panel-title {
  font-weight: 800;
  font-size: 16px;
  color: #314356;
}
.unit {
  color: #8ca0af;
  font-size: 12px;
}
.panel-body {
  padding: 18px;
}
.hbars {
  display: grid;
  gap: 9px;
  padding: 4px 2px;
  /* 最多显示 10 条（每条 22px + 间距 9px），超出在面板内部滚动 */
  max-height: 310px;
  overflow-y: auto;
}
.hrow {
  display: flex;
  align-items: center;
  gap: 10px;
}
.hname {
  width: 168px;
  min-width: 168px;
  font-size: 13px;
  color: #4a5f70;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.htrack {
  flex: 1;
  background: #eef4f8;
  border-radius: 7px;
  height: 22px;
  overflow: hidden;
}
.hbar {
  height: 100%;
  border-radius: 7px;
  background: linear-gradient(90deg, #3aa8ff, #28b7ee);
  min-width: 4px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 7px;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
  transition: 0.2s;

  &:hover {
    filter: brightness(0.95);
  }
}
.hval {
  width: 126px;
  min-width: 126px;
  text-align: right;
  font-size: 12px;
  color: #7f93a6;

  b {
    color: #243a4b;
    font-size: 13px;
  }
}
.empty {
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  font-size: 14px;
}

@media (max-width: 680px) {
  .hname {
    width: 110px;
    min-width: 110px;
  }
  .hval {
    width: 88px;
    min-width: 88px;
  }
}
</style>
